<template>
  <div id="contenedor-main-listado-pagos">
    <template
      v-for="solicitud in listadoSolicitudes">
      <template>
        <v-card
          :key="`solicitud-${solicitud.id}`"
          class="mb-3">
          <v-card-title>
            {{ solicitud.folio }}
            <span
              class="text--secondary">
              ({{ solicitud.contrato.contratista.nombreRazonSocial }})
            </span>
            <v-spacer></v-spacer>
            <small
              class="font-weight-regular body-2">
              <fecha-humano
                :fecha="solicitud.createdAt">
              </fecha-humano>
            </small>
            <v-tooltip
              v-if="!solicitud.detalles.length > 0"
              top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" @click="borrarSolicitudPago(solicitud)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Borrar Solicitud</span>
            </v-tooltip>
            <v-btn
              v-else
              icon
              disabled>
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-subtitle>
            <router-link
            :to="{ name: 'contrato', params: { idContrato: solicitud.contrato.id } }"
            class="mr-3">
              <span class="font-weight-medium">
                {{ solicitud.contrato.numero }}
              </span>
            </router-link>
            <v-icon
              small>
              mdi-calendar
            </v-icon>
            <span>
              {{ new Date(`${solicitud.fecha} 00:00:0`).toLocaleDateString() }}
            </span>
            <span
              class="d-none">
              {{ solicitud.contrato.meta }}
            </span>
          </v-card-subtitle>
          <v-card-text>
            <detalles
              :listado="solicitud.detalles">
            </detalles>
          </v-card-text>
        </v-card>
      </template>
    </template>
  </div>
</template>

<script>
import Detalles from './Detalles.vue';
import FechaHumano from '@/components/FechaHumano.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'MainListadoPagos',
  components: {
    Detalles,
    FechaHumano,
  },
  props: {
    listado: {
      type: Array,
    },
    filtros: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  methods: {
    borrarSolicitudPago(solicitudPago) {
      eventBus.$emit('borrar-solicitud-pago', solicitudPago);
    },
  },
  computed: {
    listadoSolicitudes() {
      if (!this.listado) return [];
      return this.listado
        .filter(({ fecha }) => {
          const nuevaFecha = new Date(fecha);
          return nuevaFecha.getFullYear() === this.filtros.ejercicio;
        })
        .slice().sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    },
  },
};
</script>

<style lang="scss">

</style>
